import React, { useMemo } from "react";
import { withTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { get } from "lodash";
import PropTypes from "prop-types";
import Collapse from "./Collapse";

const NotesView = ({ applicationData, isExpandable = true, t }) => {
  const fields = useMemo(
    () => [
      {
        name: "Notes",
        key: "notes",
        isRequired: true,
      },
    ],
    []
  );

  return (
    <>
      <Collapse title={"Notes"} isExpandable={isExpandable}>
        <Row className="d-flex  mb-2">
          {fields.map(({ name, key, isRequired, renderField }) => {
            const value = get(applicationData, key, "");
            return (
              <Col key={key} lg={6} className="mb-1">
                <Row>
                  <Col
                    md={7}
                    style={{ wordBreak: "break-word" }}
                  >
                    {renderField
                      ? renderField(value)
                      : get(applicationData, key, null) ??
                        (isRequired ? "-" : "N/A")}
                  </Col>
                </Row>
              </Col>
            );
          })}
        </Row>
      </Collapse>
    </>
  );
};

NotesView.propTypes = {
  applicationData: PropTypes.object,
  isExpandable: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslation()(NotesView);
